import { render, staticRenderFns } from "./workOver-lead.vue?vue&type=template&id=4b95bbf5&scoped=true&"
import script from "./workOver-lead.vue?vue&type=script&lang=js&"
export * from "./workOver-lead.vue?vue&type=script&lang=js&"
import style0 from "./workOver-lead.vue?vue&type=style&index=0&id=4b95bbf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95bbf5",
  null
  
)

export default component.exports